import Vue from 'vue';
import VueTour from 'vue-tour';
import VueGtag from 'vue-gtag';
import VueCookies from 'vue-cookies';
import VueIziToast from 'vue-izitoast';
import VueCryptojs from 'vue-cryptojs';
import VuetifyNumberInput from '@jzolago/vuetify-number-input';
import IdleVue from 'idle-vue';
import { createPinia, PiniaVuePlugin } from 'pinia';
import Auth from '@aws-amplify/auth';
import store from '@/store';
import initialize from '@/utils/initialize';
import AuthConfig from '@/utils/aws-exports';
import { configureAmplifyForSavedPool } from '@/utils/portalPool';
import { PacisNotify } from '@/utils/errorInterpreter';
import vuetify from './plugins/vuetify';
import router from './router';
import App from './App';
import '@/assets/css/agent-tour.css';
import '@/assets/css/tailwind.css';
import '@/assets/css/color/default.css';
import '@/assets/css/agent-dashboard.css';
import '@/assets/css/nprogress.css';
import '@/assets/css/style.css';
import '@/assets/css/auth-modern.css';
import '@/assets/css/customer-ui.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'izitoast/dist/css/iziToast.min.css';
import './plugins/vuetify-money';
import './plugins/vue-timeago';
import './registerServiceWorker';
import firebase from './services/firebase/firebase';

import './providers/ProviderHome';

require('vue-tour/dist/vue-tour.css');

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

Vue.use(VueTour);

Vue.use(VueGtag, {
  config: { id: 'G-1HC3ELBWY9' },
}, router);

Vue.use(VuetifyNumberInput);

Vue.use(VueCryptojs);

Vue.use(PacisNotify);

Vue.use(VueIziToast, { position: 'topRight', timeout: 5000 });

const eventsHub = new Vue();
Vue.prototype.$eventsHub = eventsHub;

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 3300000, // 55 minutes
  startAtIdle: false,
  events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
});

Vue.use(VueCookies);
Vue.$cookies.config('7d', null, null, true, 'Strict');

Auth.configure(AuthConfig);
configureAmplifyForSavedPool(AuthConfig);

async function bootstrapApp() {
  await store.dispatch('auth/validateStoredSession');
  initialize.init(router, store);

  firebase.analytics();
  Vue.prototype.$analytics = firebase.analytics();

  Vue.config.productionTip = false;

  new Vue({
    pinia,
    vuetify,
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');

  Vue.nextTick(() => {
    if (typeof window.pacisHideBootSplash === 'function') {
      window.pacisHideBootSplash();
    }
  });
}

bootstrapApp();
